export default {
  title: 'Własna domena',
  description:
    'Aplikacje zespołu mogą działać we własnej domenie zamiast pod wspólnym adresem. Domenę podłącza się raz: panel, portal zamówień, edytor strony i studio strony otrzymują w niej osobne adresy.',
  read_only_description:
    'Domena, w której ten partner uruchamia swoje aplikacje. Tylko partner może ją podłączyć lub odłączyć.',
  read_only_empty: 'Ten partner nie podłączył żadnej domeny.',
  not_connected: {
    label: 'Domena',
    hint: 'Własna domena, bez www — na przykład twojamarka.pl. Następnie dodaj wyświetlone rekordy DNS u dostawcy domeny.',
    placeholder: 'twojamarka.pl',
    connect: 'Podłącz',
  },
  apps: {
    dashboard: 'Panel',
    oms: 'Portal zamówień',
    storefront: 'Edytor strony',
    website_studio: 'Studio strony',
  },
  status: {
    active: 'Aktywna',
    pending: 'Oczekuje na DNS',
    failed: 'Wymaga uwagi',
    disabled: 'Odłączona',
  },
  records: {
    title: 'Dodaj te rekordy DNS dla {{root}} u dostawcy domeny',
  },
  instructions: {
    title: 'Jak dodać rekordy',
    step_provider:
      'Należy zalogować się tam, gdzie zarządzany jest DNS domeny {{root}} — zwykle u firmy, w której kupiono domenę, lub w usłudze DNS, takiej jak Cloudflare.',
    step_add:
      'W ustawieniach DNS domeny {{root}} należy dodać każdy rekord poniżej: wybrać typ, a następnie skopiować nazwę i wartość bez zmian. TTL można zostawić domyślny.',
    step_check:
      'Po zapisaniu rekordów należy kliknąć „{{button}}”. Większość dostawców publikuje zmiany w ciągu kilku minut; niektórym zajmuje to do 48 godzin.',
    tip_name:
      'W polu nazwy większość dostawców oczekuje tylko części przed {{root}}, wyróżnionej pogrubieniem. Jeśli dostawca wymaga pełnej nazwy, należy skopiować tę podaną poniżej.',
    tip_cloudflare:
      'W Cloudflare rekordy CNAME należy ustawić na „Tylko DNS” (szara chmura). Rekord przez proxy ukrywa CNAME, więc domeny nie da się zweryfikować.',
    tip_existing:
      'Istniejących rekordów dla {{root}} i www nie należy zmieniać — strona internetowa działa dalej bez zmian.',
  },
  summary: {
    live: 'Panel działa pod adresem {{host}}.',
    pending: 'Regularnie sprawdzamy rekordy DNS. Znalezienie nowych rekordów może potrwać do 48 godzin.',
    failed:
      'Niektórych rekordów nie udało się zweryfikować. Należy poprawić oznaczone poniżej rekordy i sprawdzić ponownie.',
    relogin:
      'Gdy {{host}} zacznie działać, zespół będzie logować się tam. Przy pierwszej wizycie konieczne będzie ponowne zalogowanie.',
  },
  buttons: {
    check_again: 'Sprawdź ponownie',
    disconnect: 'Odłącz',
    retry: 'Spróbuj ponownie',
  },
  disconnect_confirm: {
    title: 'Odłączyć {{root}}?',
    description: 'Aplikacje wrócą pod wspólny adres, a linki w {{root}} przestaną działać.',
    ok: 'Odłącz',
  },
  toasts: {
    load_error: 'Nie udało się wczytać domeny.',
    load_error_read_only: 'Nie udało się wczytać domeny tego partnera.',
    connected: 'Domena podłączona. Dodaj poniższe rekordy DNS.',
    connect_failed: 'Nie udało się podłączyć domeny.',
    check_started: 'Sprawdzanie rekordów DNS.',
    check_failed: 'Nie udało się rozpocząć sprawdzania. Spróbuj ponownie za minutę.',
    disconnected: 'Domena odłączona.',
    disconnect_failed: 'Nie udało się odłączyć domeny.',
  },
};
